import * as types from "../constants/ActionTypes";

const initialState = {
    loading: false
}

export default function isLoadingReducer(state = initialState, action) {
    if (action.type === types.HIDE_LOADING) {
        return { loading: false }
    }

    if (action.type === types.SHOW_LOADING) {
        return { loading: true }
    }

    return state;
}